import React, { Component } from 'react'

class Whitespace extends Component {
	render() {
		return (
			<div
				style={{
					padding: this.props.padding || '0'
				}}
			></div>
		)
	}
}

export default Whitespace


// WEBPACK FOOTER //
// ./src/components/Whitespace.js